/***********************************************************************
 *                           字符串操作工具类                           *
 * ********************************************************************/

/*
   * 判断字符串是否为空

   */
String.prototype.isEmpty = function() {
  var str = this.toString()
  if (str == null || str.trim().length == 0) {
    return true
  } else {
    return false
  }
}
/*
 * 判断两个字符串子否相同
 * @param str1
 * @param str2
 * @returns {Boolean}
 */
String.prototype.isEquals = function(str) {
  if (this == str) {
    return true
  } else {
    return false
  }
}
/*
 * 忽略大小写判断字符串是否相同
 * @param str1
 * @param str2
 * @returns {Boolean}
 */
String.prototype.isEqualsIgnorecase = function(str) {
  if (this.toUpperCase() == str.toUpperCase()) {
    return true
  } else {
    return false
  }
}
/**
 * 判断是否是数字
 * @param value
 * @returns {Boolean}
 */
export function isNum(value) {
  if (value != null && value.length > 0 && isNaN(value) == false) {
    return true
  } else {
    return false
  }
}

/**
 * 判断是否是中文
 * @param str
 * @returns {Boolean}
 */
String.prototype.isChine = function() {
  var reg = /^([u4E00-u9FA5]|[uFE30-uFFA0])*$/
  if (reg.test(this)) {
    return false
  }
  return true
}
/**
 * 去除字符串空格
 * @param str 要处理的字符串
 * @param type 1：所有空格 2：前后空格 3：前空格 4：后空格
 */
String.prototype.strTrim = function(type) {
  var type = type || 1
  switch (type) {
    case 1:
      return this.replace(/\s+/g, '')
    case 2:
      return this.replace(/(^\s*)|(\s*$)/g, '')
    case 3:
      return this.replace(/(^\s*)/g, '')
    case 4:
      return this.replace(/(\s*$)/g, '')
    default:
      return this
  }
}



// WEBPACK FOOTER //
// ./src/utils/string.js